import { render, staticRenderFns } from "./teated.vue?vue&type=template&id=7a16effa&"
import script from "./teated.vue?vue&type=script&lang=js&"
export * from "./teated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports